import React from 'react';
import { Play, Star, Quote } from 'lucide-react';
import { Marquee } from './magicui/Marquee';

const TESTIMONIALS = [
  {
    id: 1,
    name: 'Maya S.',
    initials: 'MS',
    avatarBg: 'bg-amber-500/20 text-amber-800 dark:text-amber-300 border-amber-400/40',
    role: 'Grade 12 Pre-Med Student',
    target: 'McMaster Health Sciences',
    quote: 'Kian’s active recall method shifted my Chemistry mark from 78% to 94%. I stopped re-reading textbook notes and mastered active problem sets.',
    videoYoutubeId: 'dQw4w9WgXcQ'
  },
  {
    id: 2,
    name: 'Daniel K.',
    initials: 'DK',
    avatarBg: 'bg-emerald-500/20 text-emerald-800 dark:text-emerald-300 border-emerald-400/40',
    role: 'Grade 12 Engineering Track',
    target: 'Waterloo Software Engineering',
    quote: 'Kian’s step-by-step calculus proofs and active recall frameworks took my Grade 12 Functions mark to 93%. I felt fully prepared for Waterloo entrance cut-offs.',
    videoYoutubeId: 'dQw4w9WgXcQ'
  },
  {
    id: 3,
    name: 'Sarah L.',
    initials: 'SL',
    avatarBg: 'bg-blue-500/20 text-blue-800 dark:text-blue-300 border-blue-400/40',
    role: 'Grade 12 Student',
    target: 'UofT Life Sciences',
    quote: 'The age gap with older tutors was huge. Having Kian as a relatable peer mentor who recently aced the exact same courses was game-changing.',
    videoYoutubeId: 'dQw4w9WgXcQ'
  },
  {
    id: 4,
    name: 'Alex T.',
    initials: 'AT',
    avatarBg: 'bg-red-500/20 text-red-800 dark:text-red-300 border-red-400/40',
    role: 'Grade 12 Student',
    target: 'McGill Pre-Med Track',
    quote: 'Active recall drills doubled my problem-solving speed in Advanced Functions & Calculus. Locked my 92% average before midterms.',
    videoYoutubeId: 'dQw4w9WgXcQ'
  },
  {
    id: 5,
    name: 'Liam M.',
    initials: 'LM',
    avatarBg: 'bg-indigo-500/20 text-indigo-800 dark:text-indigo-300 border-indigo-400/40',
    role: 'Grade 11 Student',
    target: 'UBC Science Track',
    quote: 'The active problem-solving drills with Kian eliminated exam panic. I went from struggling with Chemistry Stoichiometry to locking my 91% average.',
    videoYoutubeId: 'dQw4w9WgXcQ'
  }
];

export function TestimonialSlider({ onOpenVideo }) {
  return (
    <div className="relative overflow-hidden py-4 space-y-4">
      <div className="flex items-center justify-between px-2">
        <div className="flex items-center gap-2">
          <Quote className="h-5 w-5 text-amber-500" />
          <span className="text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300">
            Verified Student Transformations (Hover to Pause)
          </span>
        </div>
        <div className="flex items-center gap-1 text-amber-500">
          <Star className="h-4 w-4 fill-amber-500" />
          <Star className="h-4 w-4 fill-amber-500" />
          <Star className="h-4 w-4 fill-amber-500" />
          <Star className="h-4 w-4 fill-amber-500" />
          <Star className="h-4 w-4 fill-amber-500" />
          <span className="text-xs font-bold text-slate-800 dark:text-slate-200 ml-1">5.0 / 5.0 Rating</span>
        </div>
      </div>

      {/* Magic UI Marquee Testimonial Cards Track */}
      <Marquee pauseOnHover className="[--duration:35s] py-2">
        {TESTIMONIALS.map((item) => (
          <div
            key={item.id}
            className="w-80 sm:w-96 flex-shrink-0 rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900/80 shadow-sm backdrop-blur-md space-y-4 transition-transform duration-300 hover:scale-[1.02]"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                {/* Student Avatar Badge */}
                <div className={`h-10 w-10 rounded-full border flex items-center justify-center font-extrabold text-sm ${item.avatarBg}`}>
                  {item.initials}
                </div>
                <div>
                  <div className="font-bold text-slate-900 dark:text-white text-base">{item.name}</div>
                  <div className="text-xs text-amber-600 dark:text-amber-400 font-semibold">{item.role}</div>
                </div>
              </div>
              <span className="px-2.5 py-1 rounded-full bg-amber-500/10 border border-amber-400/30 text-amber-800 dark:text-amber-300 text-[11px] font-bold">
                {item.target}
              </span>
            </div>

            <p className="text-xs sm:text-sm text-slate-700 dark:text-slate-300 italic leading-relaxed">
              "{item.quote}"
            </p>

            <div className="pt-2 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between">
              <div className="flex items-center gap-1 text-amber-500">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-3 w-3 fill-amber-500" />
                ))}
              </div>
              <button
                onClick={() => onOpenVideo(item.videoYoutubeId)}
                className="inline-flex items-center gap-1.5 text-xs font-bold text-amber-600 dark:text-amber-400 hover:text-amber-500 transition"
              >
                <Play className="h-3 w-3 fill-amber-500" /> Watch Story
              </button>
            </div>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
